"use client";

import type { NextPage } from "next";
import { type SVGProps, useId } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  from?: string;
  to?: string;
  width?: string;
  height?: string;
}

const HeartStateTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from = "#DD3422",
  to = "#FC3B26",
  isGradient = false,
  width = "100%",
  height = "100%",
  ...props
}) => {
  const id = useId();
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={id}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.9917 21C11.3227 21 10.6571 20.7926 10.089 20.3799L3.88608 15.6299C2.71449 14.7791 2 13.355 2 11.8374V8.94951C2 7.26315 2.80406 5.61238 4.20613 4.42004C5.10805 3.65259 6.19693 3.17586 7.3548 3.04066C7.53245 3.01423 8.00861 3 8.03602 3C9.50612 3 10.9111 3.55805 12 4.53897C13.0889 3.55806 14.4939 3 15.964 3C15.9914 3 16.4622 3.01423 16.6697 3.0427C17.8016 3.17383 18.8915 3.65259 19.7944 4.42106C21.196 5.6134 22 7.26214 22 8.94443V11.8374C22 13.354 21.2855 14.7791 20.089 15.6482L13.935 20.3616C13.3477 20.7886 12.668 21 11.9917 21Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={`${id}`}
          x1="2"
          y1="13.663"
          x2="22"
          y2="13.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HeartStateTrueIcon;
